const actionTypeIdentifier = '52D96BF6-F462-4F28-8CD1-A5CE53EE5477';

export const getHrUploadTypes = `GET-HR-UPLOAD-TYOES${actionTypeIdentifier}`;
export const setHrUploadError = `SET-HR-UPLOAD-ERROR${actionTypeIdentifier}`;

export const HrUploadModel = {
    hrUploadTypeId: 0,
    files: []
}